import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import he from 'he';
export var encodeHtmlEntities = function encodeHtmlEntities(html) {
  return he.encode(html);
};
export var decodeHtmlEntities = function decodeHtmlEntities(html) {
  return he.decode(html);
};
export var stripHtmlTags = function stripHtmlTags(html) {
  return html.replace(/<[^>]*>?/gm, '');
};